<template>
  <div class="file-man">
    <!-- 面包屑 -->
    <Breadcrumb :crumb="crumb" />
    <div class="contain" v-if="warningMenuInfoList.length > 0">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="item in warningMenuInfoList"
          :label="item.modelName"
          :key="item.id"
          :name="item.modelCode"
          class="el-tab-pane-box"
        >
          <div>
            <el-radio v-model="form.classify" label="percent">百分比</el-radio>
            <el-radio v-model="form.classify" label="score">积分</el-radio>
          </div>
          <div class="form-info">
            <el-row
              :gutter="10"
              align="middle"
              v-for="(item, index) in form.valueInfoList"
              class="el-row-box"
              :key="item.level"
            >
              <el-col
                class="desc"
                style="height: 40px; line-height: 40px"
                :span="2"
              >
                {{ item.desc }}
              </el-col>
              <el-col :span="2">
                <el-input
                  type="number"
                  readonly
                  class="no-border"
                  v-model="item.minValue"
                />
              </el-col>
              <el-col style="height: 40px; line-height: 40px" :span="1">
                ~</el-col
              >
              <el-col :span="3">
                <el-input
                  :readonly="index == 2"
                  :class="index == 2 ? 'no-border' : ''"
                  type="number"
                  @change="onChangeInput(item)"
                  v-model="item.maxValue"
                  :min="0"
                  :max="100"
                />
              </el-col>
              <el-col
                v-if="form.classify === 'percent'"
                style="height: 40px; line-height: 40px"
                :span="1"
              >
                %</el-col
              >
            </el-row>
            <el-button :loading="btnLoading" type="primary" @click="onSave"
              >保存</el-button
            >
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { mapState } from "vuex";
export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      //面包屑
      crumb: {
        list: ["系统管理", "预警管理"],
        //titBig:"默认为list最后一位，也可更改"
      },
      warningMenuInfoList: [],
      activeName: "",
      btnLoading: false,
      form: {
        classify: "percent",
        valueInfoList: [
          {
            id: null,
            desc: "无需预警",
            level: 1,
            minValue: 0,
            maxValue: null,
          },
          {
            id: null,
            desc: "轻度预警",
            level: 2,
            minValue: null,
            maxValue: null,
          },
          {
            id: null,
            desc: "重度预警",
            level: 3,
            minValue: null,
            maxValue: 100,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getWarningMenuInfoList();
  },
  methods: {
    checkData(list) {
      return list.every((item, index, arr) => {
        if (index == 2) {
          return item.minValue < item.maxValue <= 100;
        } else {
          return (
            item.maxValue < arr[index + 1].maxValue <= 100 &&
            item.minValue < item.maxValue <= 100
          );
        }
      });
    },
    onChangeInput(item) {
      this.form.valueInfoList.forEach((u, i) => {
        if (item.level == u.level) {
          if (item.maxValue <= item.minValue) {
            this.$message({
              type: "warning",
              message: "最大值不能小于等于最小值",
            });
            item.maxValue = item.minValue;
          }
        }
        if (item.level + 1 == u.level) {
          u.minValue = item.maxValue;
        }
      });
    },
    onSave() {
      if (!this.form.classify) {
        this.$message({
          type: "warning",
          message: "请选择预警类型",
        });
        return;
      } else if (!this.checkData(this.form.valueInfoList)) {
        this.$message({
          type: "warning",
          message: "填写数据有误",
        });
        return;
      } else {
        this.btnLoading = true;
        let formData = {
          operatorId: this.userInfo.userId,
          schoolCode: this.userInfo.schoolCode,
          classify: this.form.classify,
          modelCode: this.activeName,
          valueInfoList: this.form.valueInfoList.map((u) => ({
            ...u,
            maxValue: u.maxValue / 1,
            minValue: u.minValue / 1,
          })),
        };
        this.$axios
          .post("/warning/saveOrUpdateWarningConfigInfo", formData)
          .then((res) => {
            if (res.success) {
              this.btnLoading = false;
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.getCurrentInfo();
            } else {
              this.btnLoading = false;
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
      }
    },
    handleClick(tab) {
      this.form.valueInfoList = [
        {
          desc: "无需预警",
          level: 1,
          minValue: 0,
          maxValue: null,
        },
        {
          desc: "轻度预警",
          level: 2,
          minValue: null,
          maxValue: null,
        },
        {
          desc: "重度预警",
          level: 3,
          minValue: null,
          maxValue: 100,
        },
      ];
      this.activeName = tab.name;
      this.getCurrentInfo();
    },
    getWarningMenuInfoList() {
      this.$axios
        .post(
          "/rpt/getScoreMenuInfoList",
          this.$qs.stringify({
            schoolCode: this.userInfo.schoolCode,
          })
        )
        .then(({ data }) => {
          this.warningMenuInfoList = data;
          this.activeName = data[0].modelCode;
          this.getCurrentInfo();
        });
    },
    getCurrentInfo() {
      this.$axios
        .post(
          "/warning/getWarningConfigInfo",
          this.$qs.stringify({
            schoolCode: this.userInfo.schoolCode,
            modelCode: this.activeName,
          })
        )
        .then(({ data }) => {
          this.form.classify = data.classify;
          this.form.valueInfoList.forEach((item) => {
            if (data.valueInfoList) {
              data.valueInfoList.forEach((qwe) => {
                if (qwe.level === item.level) {
                  item.minValue = qwe.minValue / 1;
                  item.maxValue = qwe.maxValue / 1;
                  item.id = qwe.id;
                }
              });
            }
          });
        });
    },
  },
};
</script>

<style  lang="less" scoped>
.file-man {
  padding: 18px;
  border-radius: 8px;

  .contain {
    background: #fff;
    padding: 20px;
    border-radius: 20px;

    .el-tab-pane-box {
      padding: 30px;
    }

    .form-info {
      margin: 50px 0;
      .no-border {
        border: none;
        /deep/ .el-input__inner {
          border: none;
        }
      }
      .el-row-box {
        margin: 20px;
        .desc {
          font-size: 16px;
          font-weight: 600;
        }
        &:nth-child(1) .desc {
          color: #37cb8c;
        }
        &:nth-child(2) .desc {
          color: #e99d42;
        }
        &:nth-child(3) .desc {
          color: #d70e19;
        }
      }
    }
  }
}
</style>